import { render, staticRenderFns } from "./formSysMenuPerm.vue?vue&type=template&id=1c4f05a3&"
import script from "./formSysMenuPerm.vue?vue&type=script&lang=js&"
export * from "./formSysMenuPerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports